export { Lightbox as MediaGallery } from '@/components/ui/lightbox';

